import { render, staticRenderFns } from "./OfficeIcon.vue?vue&type=template&id=801fdb3e"
import script from "./OfficeIcon.vue?vue&type=script&lang=js"
export * from "./OfficeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports